import { RouteObject } from 'react-router-dom';
import { Users } from './Users';

export const usersRoute: RouteObject = {
  path: 'users',
  element: <Users />,
};
